import { ACCOUNT_SETTING } from "@/setting/setting";
import { generateEventId, getEmailStorage, getExternalID, getPhoneStorage, serverTrackEvent } from "../util/util";
import { binextTrack } from "./binext.track";
import { facebookTrack } from "./facebook.track";
import { tiktokTrack } from "./tiktok.track";
import { gaTrack } from "./ga.track";
import { sha256 } from "js-sha256";

export enum TrackTypes {
  PageView = "PageView",
  AddToCart = "AddToCart",
  SetToCart = "SetToCart",
  InitiateCheckout = "InitiateCheckout",
  Purchase = "Purchase",
  CartView = "CartView",
  Lead = "Lead",
  Signup = "Signup",
  Login = "Login",
  ViewProducts = "ViewProducts",
  ViewCategory = "ViewCategory",
  ViewCollection = "ViewCollection",
  DelToCart = "DelToCart",
  Search = "Search",
  AddToWishlist = "AddToWishlist",
  ViewContent = "ViewContent",
  AddPaymentInfo = "AddPaymentInfo",
  CompleteRegistration = "CompleteRegistration",
}

declare const window: any;

export const trackEvent = async (event: TrackTypes, data:Record<string, any> = {}) => 
{
    if (typeof window === "undefined") return;

    const eventId    = generateEventId();
    const externalId = await getExternalID();
    const email      = getEmailStorage(data?.user, externalId);
    const phone      = getPhoneStorage(data?.user, externalId);

    console.log(eventId, event, data);

    // Google Analytics (GA4)
    const eventDataGA = await gaTrack(eventId, externalId, event, data);

    // Facebook
    const eventDataFB = await facebookTrack(eventId, externalId, event, data);

    // TikTok
    const eventDataTT = tiktokTrack(eventId, externalId, event, data);

    // Binext
    binextTrack(event, data);

    serverTrackEvent(ACCOUNT_SETTING.merge({ 
        event, 
        eventId    : eventId,
        externalId : sha256(externalId),
        email      : sha256(email),
        phone      : sha256(phone),
        eventFB    : eventDataFB, 
        eventTT    : eventDataTT,
        eventGA    : eventDataGA,
        url        : window.location.href
    }))
};